export default function PrimaryHeader(props) {
  return <h3 style={{ color: "#154734" }}>{props.header}</h3>;
}
